<template>
  <div class="building-quotes-page">
    <!-- Notifications Section -->
    <div class="notifications mb-4" v-if="!loadingNotifications">
      <b-alert show class="notification" v-if="showSalesLeadAlert">
        There are new sales leads to review
        <router-link class="" :to="`/app/sales/leads`">
          <b-button variant="outline-info" size="sm" style="margin-left: 6px">
            Go To Sales Leads
          </b-button>
        </router-link>
      </b-alert>
      <b-alert
        show
        class="notification"
        variant="secondary"
        v-if="!showSalesLeadAlert && !loadingNotifications"
      >
        There are no new notifications
      </b-alert>
    </div>

    <!-- Statistics Section -->
    <div class="statistics-section mb-5">
      <div v-if="loadingStats" class="text-center py-4">
        <circle-loader :size="30"></circle-loader>
        <p class="text-muted mt-2">Loading statistics...</p>
      </div>
      <quote-statistics 
        v-else
        :stats="quoteStats"
      />
    </div>

    <!-- Follow-up Section -->
    <div class="followup-section">
      <h5 class="section-title mb-3">🎯 Follow-up Required</h5>
      
      <quote-follow-up-list 
        @quote-updated="refreshStats"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import CircleLoader from '@/components/CircleLoader'
import QuoteStatistics from '@/components/QuoteStatistics'
import QuoteFollowUpList from '@/components/QuoteFollowUpList'

export default {
  name: 'BuildingQuotesPage',
  components: { 
    CircleLoader, 
    QuoteStatistics, 
    QuoteFollowUpList 
  },
  data() {
    return {
      quoteStats: {},
      loadingStats: false,
      showSalesLeadAlert: false,
      loadingNotifications: true
    }
  },
  methods: {
    async loadQuoteStats() {
      this.loadingStats = true
      try {
        const response = await axios.get('/services/v2/quotes/stats')
        this.quoteStats = response.data
      } catch (error) {
        console.error('Error loading quote statistics:', error)
        this.$bvToast.toast('Error loading quote statistics', {
          title: 'Error',
          variant: 'danger'
        })
      } finally {
        this.loadingStats = false
      }
    },

    refreshStats() {
      // Refresh stats when quotes are updated
      this.loadQuoteStats()
    },

    async checkForSalesLeadsAlert() {
      this.loadingNotifications = true
      try {
        const response = await axios.get('/services/sales-leads/show-new-alert')
        this.showSalesLeadAlert = response.data.showAlert
      } catch (error) {
        console.error('Error checking sales leads alert:', error)
      } finally {
        this.loadingNotifications = false
      }
    }
  },

  async mounted() {
    await Promise.all([
      this.loadQuoteStats(),
      this.checkForSalesLeadsAlert()
    ])
  }
}
</script>

<style lang="scss" scoped>
.building-quotes-page {
  .notifications {
    .notification {
      max-width: 800px;
    }
  }

  .page-header {
    text-align: center;
    padding: 1rem 0;

    h3 {
      color: #495057;
      font-weight: 600;
      margin-bottom: 0.5rem;
    }
  }

  .statistics-section {
    background: #ffffff;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 2rem;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  }

  .followup-section {
    background: #ffffff;
    border: 1px solid #e9ecef;
    border-radius: 12px;
    padding: 2rem;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  }

  .section-title {
    color: #495057;
    font-weight: 600;
    margin-bottom: 1rem;
    display: flex;
    align-items: center;
    
    &:before {
      content: '';
      width: 4px;
      height: 20px;
      background: #007bff;
      margin-right: 0.5rem;
      border-radius: 2px;
    }
  }
}
</style>
